import { cn } from "@/lib/utils";
import { ElementType, HTMLAttributes } from "react";

export type TextProps = HTMLAttributes<HTMLSpanElement> & {
  as?: ElementType;
};

export const Title = ({ className, as: Comp = "h2", ...props }: TextProps) => {
  return (
    <Comp
      className={cn("text-black font-semibold text-xl", className)}
      {...props}
    />
  );
};

export const Subtitle = ({
  className,
  as: Comp = "span",
  ...props
}: TextProps) => {
  return <Comp className={cn("text-gray-600 text-sm", className)} {...props} />;
};
